// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1_GAt","left":"StickyBox_left__3mGBW","right":"StickyBox_right__2BPBs"};